/* eslint-disable eqeqeq */
import { Chip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles((theme) => ({
  newChip: {
    backgroundColor: `${theme.palette.weesu.light_green} !important`,
    color: `${theme.palette.common.white} !important`,
    border: `1px solid ${theme.palette.weesu.light_green} !important`,
    marginLeft: "5px !important",
  },
}));

function NewChip() {
  const classes = useStyles();
  return <Chip size="small" label="novo" className={clsx(classes.newChip)} />;
}

export default NewChip;
